import IconInfo from '@apollo/icons/default/IconInfo.svg';
import { Badge } from '@apollo/orbit';
import React, { useMemo } from 'react';

import { FieldType } from 'src/app/graph/insights/fieldPage/useCurrentSchemaCoordinate';
import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';

import { FieldSummaryEmptyText } from '../FieldSummaryEmptyText';

interface Props {
  field: FieldType;
}

export const FieldPageTags = ({ field }: Props) => {
  const { tags, invalid } = useMemo<{ tags: string[]; invalid: number }>(() => {
    const allTags: string[] = [];
    let invalidTags: number = 0;
    field.astNode?.directives
      ?.filter(({ name }) => name.value === 'tag')
      .forEach(({ arguments: args }) => {
        const tagValue = args?.find(({ name }) => name.value === 'name')?.value;
        if (tagValue && 'value' in tagValue) {
          allTags.push(String(tagValue.value));
        } else {
          invalidTags++;
        }
      });
    return { tags: allTags, invalid: invalidTags };
  }, [field]);
  return (
    <>
      {tags.length ? (
        tags.map((name) =>
          typeof name === 'symbol' ? null : (
            <Badge key={name as string} className="mr-1">
              {name}
            </Badge>
          ),
        )
      ) : (
        <Tooltip
          className="w-[178px]"
          interactive
          placement="bottom-start"
          label={
            <div>
              Learn how to add tags{' '}
              <ClickableText
                className="text-link hover:underline"
                as="a"
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.apollographql.com/docs/studio/federated-graphs/#schema-tagging"
              >
                here
              </ClickableText>
              .
            </div>
          }
        >
          <span className="flex items-center">
            <FieldSummaryEmptyText message="No tags found." />
            <IconInfo className="ml-2 pr-1 text-secondary" />
          </span>
        </Tooltip>
      )}

      {Boolean(invalid) && (
        <FieldSummaryEmptyText message={` (${invalid} tags not shown)`} />
      )}
    </>
  );
};
